import { rufe } from './client';

/**
 * Die Datenübernahme über HTTP (Kapitel 29).
 *
 * Die Dateien gehen als Base64 im JSON — derselbe Weg wie bei den
 * Rechtstexten. Der Server entscheidet, wie sie kodiert sind: Excel schreibt
 * „CSV (Trennzeichen-getrennt)" in Windows-1252 und „CSV UTF-8" mit BOM, und
 * wer das hier als Text läse, bekäme im ersten Fall „MÃ¼ller".
 */

export type Beanstandung = {
  readonly datei: string;
  readonly zeile: number;
  readonly altkennung: string | null;
  readonly grund: string;
};

export type Uebernahmebericht = {
  readonly lauf: string;
  readonly bereich: string;
  readonly probelauf: boolean;
  readonly uebernommen: boolean;
  readonly zeilen: number;
  readonly angelegt: number;
  readonly fortgeschrieben: number;
  readonly beanstandungen: readonly Beanstandung[];
  readonly weitere: Readonly<Record<string, number>>;
};

export type Laufzeile = {
  readonly id: string;
  readonly bereich: string;
  readonly dateiname: string | null;
  readonly probelauf: boolean;
  readonly uebernommen: boolean;
  readonly zeilen: number;
  readonly angelegt: number;
  readonly fortgeschrieben: number;
  readonly beanstandet: number;
  readonly angelegtAm: string;
  readonly angelegtVon: string | null;
};

/** Eine Datei als Base64 — in Stücken, weil `String.fromCharCode(...bytes)` bei großen Dateien den Aufrufstapel sprengt. */
export async function alsBase64(datei: File): Promise<string> {
  const bytes = new Uint8Array(await datei.arrayBuffer());
  let binaer = '';
  for (let i = 0; i < bytes.length; i += 8192) {
    binaer += String.fromCharCode(...bytes.subarray(i, i + 8192));
  }
  return btoa(binaer);
}

export async function trainerUebernehmen(eingabe: {
  readonly trainerBase64: string;
  readonly qualifikationenBase64: string;
  readonly dateiname: string | null;
  readonly probelauf: boolean;
}): Promise<Uebernahmebericht> {
  return rufe('/uebernahme/trainer', { verfahren: 'POST', rumpf: eingabe });
}

export async function laeufe(): Promise<readonly Laufzeile[]> {
  const antwort = await rufe<{ readonly laeufe: readonly Laufzeile[] }>('/uebernahme/laeufe');
  return antwort.laeufe;
}

export async function beanstandungen(lauf: string): Promise<readonly Beanstandung[]> {
  const antwort = await rufe<{ readonly beanstandungen: readonly Beanstandung[] }>(
    `/uebernahme/laeufe/${lauf}/beanstandungen`,
  );
  return antwort.beanstandungen;
}
